import React from 'react';
import ReactDOM from 'react-dom';
import qs from 'query-string';
import env from "../environment";

let superagent = require('superagent');

let Request = superagent.Request;

let originalEnd = Request.prototype.end;

Request.prototype.end = function() {
    this.end = originalEnd;

    const newArgs = [(err, res) => {
      if (res.status === 401) {
        window.location = env.tashi + '/login';
      }

      arguments[0](err, res);
    }];

    this.use(function(request) {
        request.withCredentials(true);
    });

    return this.end.apply(this, newArgs);
};

module.exports = superagent;



/** WEBPACK FOOTER **
 ** ./src/app/utils/backend.js
 **/